import * as ActionTypes from 'actions/featureToggle'

const initialState = {
  isFetching: false,
  isError: false,
  fetched: false,
  items: [],
}

// Updates error message to notify about the failed fetches.
export default function featureToggle(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.FEATURETOGGLE_SAVE_REQUEST:
    case ActionTypes.FEATURETOGGLE_GET:
      return {
        ...state,
        isFetching: true,
      }
    case ActionTypes.FEATURETOGGLE_SAVE_COMPLETE:
    case ActionTypes.FEATURETOGGLE_RECEIVED:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        items: action.featureToggle,
      }  
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/featureToggle.js